module.exports = __webpack_public_path__ + "img/remark_05.930232ae.svg";